<template>
  <div class="c-resource-perm-tree">
    <div v-loading="treeLoading" class="c-resource-perm-tree__wrap">
      <p class="c-resource-perm-tree__hint">
        勾选页面资源（一级为父级模块、二级为页面，与资源管理一致）；勾选父级将联动子级。
      </p>
      <el-tree
        v-if="treeData.length"
        ref="treeRef"
        class="c-resource-perm-tree__tree"
        :data="treeData"
        node-key="resourceCode"
        show-checkbox
        check-strictly
        default-expand-all
        highlight-current
        :expand-on-click-node="false"
        :props="treeProps"
        @check="handleTreeCheck"
      />
      <div v-else-if="!treeLoading" class="c-resource-perm-tree__empty">暂无资源数据，请先维护资源管理</div>
    </div>
  </div>
</template>

<script lang="ts">
export default { name: 'CResourcePermTree', inheritAttrs: false }
</script>

<script setup lang="ts">
import { inject } from 'vue'
import { computed, ref, watch, nextTick, onMounted, useCurrentAppInstance } from '@zto/zpage'
import { C_FORM_KEY } from '@zto/zpage-ui-element'
import { buildResourceTree } from '@/utils'

const props = defineProps<{
  /** 与 CDialog / CFormItems 共用的表单 model */
  contextData?: Record<string, any>
}>()

const app = useCurrentAppInstance()
const cForm = inject<any>(C_FORM_KEY, null)

const treeRef = ref<any>(null)
const treeLoading = ref(false)
const treeData = ref<any[]>([])

const model = computed(() => props.contextData || null)

const treeProps = { children: 'children', label: 'resourceName', disabled: 'disabled' }


async function loadTree() {
  treeLoading.value = true
  try {
    const res = await app.request({
      action: {
        type: 'fuzzy-select',
        url: '/base_user/admin/resource/list'
      },
      // pageIndex: 1,
      // pageSize: 1000,
      params: {}
    })
    const list = res || []
    treeData.value = buildResourceTree(list)
    await nextTick()
    applyModelToTree()
  } catch (e) {
    console.error('加载页面权限树失败', e)
    treeData.value = []
  } finally {
    treeLoading.value = false
  }
}

function applyModelToTree() {
  const tr = treeRef.value
  const m = model.value
  if (!tr || typeof tr.setCheckedKeys !== 'function' || !treeData.value.length || !m) return
  const keys = Array.isArray(m.resourceCodes) ? m.resourceCodes : []
  tr.setCheckedKeys(keys, false)
}


function handleTreeCheck(...payload : any) {
  // console.info('🚀 ~ file:CResourcePermTree method:handleTreeCheck line:77 ----- payload', payload)
  const tr = treeRef.value
  const m = model.value
  // console.info('🚀 ~ file:CResourcePermTree method:syncCheckedToModel line:99 ----- 1')
  if (!tr || typeof tr.getCheckedKeys !== 'function' || !m) return

  const leafKeys = tr.getCheckedKeys() as string[]
  m.resourceCodes = (leafKeys || []).filter(k => !!k)
  nextTick(() => {
    cForm?.validateFields?.(['resourceCodes'])
  })
}

watch(
  () => model.value?.resourceCodes,
  () => {
    nextTick(() => applyModelToTree())
  },
  { deep: true }
)

onMounted(() => {
  loadTree()
})
</script>

<style lang="scss" scoped>
.c-resource-perm-tree {
  width: 100%;
  padding-top: 4px;
  box-sizing: border-box;

  &__hint {
    margin: 0 0 8px;
    font-size: 12px;
    color: #909399;
    line-height: 1.4;
  }

  &__wrap {
    width: 100%;
    min-height: 120px;
  }

  &__tree {
    max-height: 360px;
    overflow: auto;
    padding: 8px 0;
    border: 1px solid #ebeef5;
    border-radius: 4px;
  }

  &__empty {
    font-size: 13px;
    color: #909399;
    padding: 16px 0;
  }
}
</style>
